import { SalesRepReducerState } from './types';

export const initialState: SalesRepReducerState = {
  list: [],
  userId: '',
  newSalesRep: null,
  isSalesRepUpdated: false,
};
